import { Component, HostBinding } from '@angular/core';
import { AuthService, ScreenService, AppInfoService } from './shared/services';
import "devextreme/localization/globalize/number";
import "devextreme/localization/globalize/date";
import "devextreme/localization/globalize/currency";
import "devextreme/localization/globalize/message";
import hrMessages from "./devextreme/localization/messages/hr.json";
import hrCldrData from "./devextreme-cldr-data/hr.json";
import supplemental from "devextreme-cldr-data/supplemental.json";
import Globalize from 'globalize';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  {
  @HostBinding('class') get getClass() {
    return Object.keys(this.screen.sizes).filter(cl => this.screen.sizes[cl]).join(' ');
  }

  locale: string;
  locales: Locale[];

  constructor(private authService: AuthService, private screen: ScreenService, public appInfo: AppInfoService) {
    this.locale = this.getLocale();
    this.locales = [{"Name": "English", "Value": "en"}, {"Name": "Hrvatski", "Value": "hr"}];
    this.setLocale(this.locale);
    this.initGlobalize();
    Globalize.locale(this.locale);
  }

  initGlobalize() {
    Globalize.load(
      supplemental, hrCldrData
    );
    Globalize.loadMessages(hrMessages);
  }

  getLocale() {
    var locale = sessionStorage.getItem("locale");
    return locale = "hr";
    // return locale != null ? locale : "hr";
  }

  setLocale(locale) {
    sessionStorage.setItem("locale", locale);
  }

  isAutorized() {
    return this.authService.isLoggedIn;
  }
}

export class Locale {
  Name: string;
  Value: string;
}
